import { render } from "./StatusOrderHistory.vue?vue&type=template&id=5acd1f6e&scoped=true&ts=true"
import script from "./StatusOrderHistory.vue?vue&type=script&lang=ts"
export * from "./StatusOrderHistory.vue?vue&type=script&lang=ts"

import "./StatusOrderHistory.vue?vue&type=style&index=0&id=5acd1f6e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5acd1f6e"]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QTr from 'quasar/src/components/table/QTr.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QBtn,QTable,QTr,QTh,QTd,QIcon});
